module.exports = __webpack_public_path__ + "media/promo/promo/images/recbg-2-6c7cdbfd780cd2640460ca17a9b1ab40.png";